import { faEdit } from '~components/icon';
import { Column, Row } from '~components/table-view-v3';
import { linkCellRender } from '~components/table-view-v3/columnRenderers';

import { UserRow } from '~care-workers/reducers/users';

import AccessTags from '../components/AccessTags';

const columnsFactory = (users: UserRow[], toggleModal: (id: string) => void): Column[] => [
  {
    id: 'name',
    header: 'Name',
    type: 'text',
    isEditable: false,
    renderReadOnly: linkCellRender((row: Row) => toggleModal(String(row.id)), faEdit),
  },
  {
    id: 'createdby_id',
    header: 'Created By',
    type: 'text',
    isEditable: false,
    deriveValue: (row) => users.find((user) => user.id === row.createdby_id)?.full_name ?? 'N/A',
  },
  {
    id: 'expires_at',
    header: 'Expires At',
    type: 'datetime',
    isEditable: false,
  },
  {
    id: 'access_list',
    header: 'Access Tags',
    type: 'custom',
    isEditable: false,
    component: AccessTags,
    componentProps: (row: Row) => ({ rowData: row }),
  },
  {
    id: 'is_deleted',
    header: 'Status',
    type: 'text',
    isEditable: false,
    deriveValue: (row) => (row.is_deleted ? 'Deleted' : 'Active'),
  },
];

export default columnsFactory;
